document.addEventListener('DOMContentLoaded', function () {
  const sliders = document.querySelectorAll('.slider--desktop');

  sliders.forEach(slider => {
    let isDown = false;
    let startX;
    let scrollLeft;
    let isDragging = false;
    let velocity = 0;
    let lastX = 0; 

    slider.addEventListener('mousedown', (e) => {
      isDown = true;
      isDragging = false;
      slider.classList.add('active');
      startX = e.pageX - slider.offsetLeft;
      scrollLeft = slider.scrollLeft;
      lastX = startX;
      velocity = 0;
      e.preventDefault();
    });

    slider.addEventListener('mouseleave', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('active');
        applyVelocity(slider);
      }
    });

    slider.addEventListener('mouseup', () => {
      if (isDown) {
        isDown = false;
        slider.classList.remove('active');
        applyVelocity(slider);
      }
    });

    slider.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      isDragging = true;
      e.preventDefault();
      const x = e.pageX - slider.offsetLeft;
      const walk = (x - startX) * 1.5;
      velocity = (x - lastX) * 1.5; 
      lastX = x; 
      slider.scrollLeft = scrollLeft - walk;
    });

    slider.addEventListener('click', (e) => {
      if (isDragging) {
        e.preventDefault();
      }
    });

    function applyVelocity(slider) {
      if (Math.abs(velocity) > 0.5) {
        slider.scrollLeft -= velocity;
        velocity *= 0.95; 
        requestAnimationFrame(() => applyVelocity(slider));
      } else {
        velocity = 0;
      }
    }
  });
});
